// QL-345 — which SSO provider id this tab's sign-in went through. The login form
// sets it right before redirecting to the IdP; the app reads it after the round
// trip to tell SSO sign-ins through a not-yet-confirmed provider id apart from
// password sign-ins. Per tab (sessionStorage) and cleared on every login page visit.

const SSO_LOGIN_MARKER_KEY = "qp.ssoLoginProviderId";

export function markSsoLogin(providerId: string): void {
  try {
    sessionStorage.setItem(SSO_LOGIN_MARKER_KEY, providerId);
  } catch {
    // Storage unavailable: the heads-up is best-effort
  }
}

export function readSsoLoginMarker(): string | null {
  try {
    return sessionStorage.getItem(SSO_LOGIN_MARKER_KEY);
  } catch {
    return null;
  }
}

export function clearSsoLoginMarker(): void {
  try {
    sessionStorage.removeItem(SSO_LOGIN_MARKER_KEY);
  } catch {
    // Storage unavailable
  }
}
